'use client'

import type { ReactNode } from 'react'
import type { UseFieldGridFieldProps } from '../../../hooks/use-field-grid-field.ts'
import type { TestIds } from '../../../utils/testing.ts'
import {
  AvatarSkeleton,
  type AvatarSkeletonProps,
} from '../../avatar/loading/avatar-skeleton.tsx'
import { SkeletonParagraph } from '../../skeleton/skeleton-paragraph.tsx'
import { SkeletonText } from '../../skeleton/skeleton-text.tsx'
import { DataListItem } from '../data-list-item.tsx'
import { useDataListContext } from '../use-data-list.ts'

export type DataListItemSkeletonProps = TestIds &
  Pick<UseFieldGridFieldProps, 'columnSpan'> & {
    avatarSize?: AvatarSkeletonProps['size']
    children?: ReactNode
    className?: string
    lines?: number
  }

export const DataListItemSkeleton = ({
  avatarSize,
  children,
  lines = 1,
  ...dataListItemProps
}: DataListItemSkeletonProps) => {
  const { fontSize } = useDataListContext()

  if (children) {
    return <DataListItem {...dataListItemProps}>{children}</DataListItem>
  }

  if (avatarSize) {
    return (
      <DataListItem {...dataListItemProps}>
        <AvatarSkeleton size={avatarSize} />
      </DataListItem>
    )
  }

  return (
    <DataListItem {...dataListItemProps}>
      <SkeletonText textSize={fontSize} className="w-20" />
      {lines > 1 ? (
        <SkeletonParagraph textSize={fontSize} lines={lines} />
      ) : (
        <SkeletonText textSize={fontSize} />
      )}
    </DataListItem>
  )
}
